'use strict';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}

// Array.prototype.includes polyfill for IE11
if(!Array.prototype.includes) {
  require('core-js/fn/array/includes');
}

// Array.prototype.find polyfill for IE11
if(!Array.prototype.find) {
  require('core-js/fn/array/find');
}

// String.proptotype.includes polyfill for IE11
if(!String.prototype.includes) {
  require('core-js/fn/string/includes');
}

// Function.prototype.name polyfill for IE11
if (!Function.name) {
  require('core-js/fn/function/name');
}


//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 1049
// module chunks = 0